import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "academic/:curriculumProgramId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "academic-course-codes" */ "./components"),
      import(
        /* webpackChunkName: "academic-course-codes" */ "./modules/AcademicCourseCodesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "academicCourseCodes",
        reducer,
      });

      return component;
    })
  ),
});
